import { render } from "./App.vue?vue&type=template&id=887c05da"
const script = {}

import "./App.vue?vue&type=style&index=0&id=887c05da&lang=scss"

import exportComponent from "/Users/niels/Development/kentaa-time/vue/playground/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__